(function () {
  'use strict';
  if (window.__zestiesSocialProofInit) return;
  window.__zestiesSocialProofInit = true;

  function parseFeed() {
    var el = document.getElementById('zesties-social-proof-feed');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function num(value, fallback, allowZero) {
    var n = Number(value);
    if (!isFinite(n) || n < 0) return fallback;
    if (n === 0 && !allowZero) return fallback;
    return n;
  }

  function parseConfig() {
    var defaults = { firstDelayMs: 10000, fadeMs: 500, holdMs: 1000, gapMs: 3000 };
    var el = document.getElementById('zesties-social-proof-config');
    if (!el) return defaults;
    try {
      var data = JSON.parse(el.textContent || '{}') || {};
      return {
        firstDelayMs: num(data.firstDelayMs, defaults.firstDelayMs, true),
        fadeMs: num(data.fadeMs, defaults.fadeMs, false),
        holdMs: num(data.holdMs, defaults.holdMs, false),
        gapMs: num(data.gapMs, defaults.gapMs, false)
      };
    } catch (e) {
      return defaults;
    }
  }

  function honestTime(iso) {
    if (!iso) return '';
    var then = new Date(iso);
    if (isNaN(then.getTime())) return '';
    var now = new Date();
    var diffMs = now.getTime() - then.getTime();
    if (diffMs < 0) diffMs = 0;
    // Older than 14 days: still show the toast, just without a relative age.
    if (diffMs > 14 * 24 * 60 * 60 * 1000) return 'Purchased recently';
    var mins = Math.floor(diffMs / 60000);
    var hours = Math.floor(mins / 60);
    var days = Math.floor(hours / 24);
    if (mins < 2) return 'just now';
    if (mins < 60) return mins + ' minutes ago';
    if (hours === 1) return '1 hour ago';
    if (hours < 24) return hours + ' hours ago';
    if (days === 1) return '1 day ago';
    if (days < 14) return days + ' days ago';
    if (days < 45) {
      var weeks = Math.max(2, Math.round(days / 7));
      return weeks + ' weeks ago';
    }
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return 'in ' + months[then.getMonth()] + ' ' + then.getFullYear();
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var feed = parseFeed().filter(function (item) {
    return item && item.title && item.createdAt;
  });
  if (!feed.length) return;
  if (window.sessionStorage && sessionStorage.getItem('zestiesSocialProofDismissed') === '1') return;

  var cfg = parseConfig();
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fadeMs = reduced ? 0 : cfg.fadeMs;
  var idx = 0;
  var timer = null;
  var dismissed = false;

  var wrap = document.createElement('aside');
  wrap.id = 'zesties-social-proof';
  wrap.setAttribute('aria-live', 'polite');
  wrap.setAttribute('aria-atomic', 'true');
  wrap.style.cssText = [
    'position:fixed',
    'left:16px',
    'bottom:24px',
    'z-index:40',
    'max-width:min(340px,calc(100vw - 32px))',
    'pointer-events:none',
    'font-family:inherit'
  ].join(';');

  var card = document.createElement('div');
  card.setAttribute('role', 'status');
  card.style.cssText = [
    'display:none',
    'pointer-events:auto',
    'background:#fff',
    'color:#111',
    'border:1px solid rgba(0,0,0,.08)',
    'box-shadow:0 8px 28px rgba(0,0,0,.16)',
    'border-radius:12px',
    'padding:10px 36px 10px 10px',
    'align-items:center',
    'gap:10px',
    'line-height:1.35',
    'position:relative',
    'opacity:0',
    'transform:translateY(10px)',
    'will-change:opacity,transform'
  ].join(';');

  var close = document.createElement('button');
  close.type = 'button';
  close.setAttribute('aria-label', 'Dismiss recent purchase notification');
  close.textContent = '\u00d7';
  close.style.cssText = [
    'position:absolute',
    'top:4px',
    'right:6px',
    'border:0',
    'background:transparent',
    'font-size:20px',
    'line-height:1',
    'cursor:pointer',
    'color:#666',
    'padding:4px 6px',
    'pointer-events:auto'
  ].join(';');

  wrap.appendChild(card);
  document.body.appendChild(wrap);

  function placeForMobile() {
    var sticky = window.matchMedia('(max-width: 749px)').matches;
    wrap.style.bottom = sticky ? '88px' : '24px';
    wrap.style.left = '16px';
  }
  placeForMobile();
  window.addEventListener('resize', placeForMobile);

  function clearTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function later(ms, fn) {
    clearTimer();
    timer = setTimeout(fn, Math.max(0, ms));
  }

  close.addEventListener('click', function () {
    dismissed = true;
    clearTimer();
    card.style.display = 'none';
    wrap.style.display = 'none';
    try { sessionStorage.setItem('zestiesSocialProofDismissed', '1'); } catch (e) {}
  });

  function showIndex(i) {
    var item = feed[i % feed.length];
    var name = item.name || 'Someone';
    var city = item.city || '';
    var region = item.region || '';
    var loc = city && region ? (city + ', ' + region) : (city || region);
    var title = item.title || 'a product';
    var when = honestTime(item.createdAt);
    var img = item.image || '';
    var html = '';
    if (img) {
      html += '<img alt="" width="56" height="56" src="' + escapeHtml(img) + '" style="width:56px;height:56px;object-fit:cover;border-radius:8px;flex:0 0 56px;">';
    }
    html += '<div style="min-width:0">';
    html += '<div style="font-size:13px;font-weight:600">';
    html += escapeHtml(name);
    if (loc) html += ' in ' + escapeHtml(loc);
    html += '</div>';
    html += '<div style="font-size:13px">purchased ' + escapeHtml(title) + '</div>';
    if (when) html += '<div style="font-size:12px;color:#666;margin-top:2px">' + escapeHtml(when) + '</div>';
    html += '</div>';
    card.innerHTML = html;
    card.appendChild(close);
  }

  function setHiddenPose() {
    card.style.opacity = '0';
    card.style.transform = 'translateY(10px)';
  }

  function setShownPose() {
    card.style.opacity = '1';
    card.style.transform = 'translateY(0)';
  }

  function applyFadeTransition(ms) {
    if (!ms) {
      card.style.transition = 'none';
      return;
    }
    card.style.transition = 'opacity ' + ms + 'ms ease, transform ' + ms + 'ms ease';
  }

  function fadeInThenHold() {
    if (dismissed) return;
    showIndex(idx);
    card.style.display = 'flex';
    if (reduced) {
      applyFadeTransition(0);
      setShownPose();
      later(cfg.holdMs, fadeOutThenGap);
      return;
    }
    applyFadeTransition(0);
    setHiddenPose();
    void card.offsetWidth;
    applyFadeTransition(fadeMs);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (dismissed) return;
        setShownPose();
        later(fadeMs + cfg.holdMs, fadeOutThenGap);
      });
    });
  }

  function fadeOutThenGap() {
    if (dismissed) return;
    if (reduced) {
      applyFadeTransition(0);
      setHiddenPose();
      card.style.display = 'none';
      later(cfg.gapMs, nextToast);
      return;
    }
    applyFadeTransition(fadeMs);
    setHiddenPose();
    later(fadeMs, function () {
      if (dismissed) return;
      card.style.display = 'none';
      later(cfg.gapMs, nextToast);
    });
  }

  function nextToast() {
    if (dismissed) return;
    idx = (idx + 1) % feed.length;
    fadeInThenHold();
  }

  later(cfg.firstDelayMs, fadeInThenHold);
})();
